import { REACT_APP_API_PANEL_URL, REACT_APP_PROJECT_NAME } from 'src/constants/base';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const {
  NEWS: { FIND_ALL, FIND_ONE, LANGUAGE_LINKS },
} = API_ENDPOINTS;

export const ApiNews = {
  getLanguageLinks: (id: string | number) => {
    return API({
      path: REACT_APP_API_PANEL_URL + LANGUAGE_LINKS,
      method: 'GET',
      pathParams: { id },
      headers: { project: REACT_APP_PROJECT_NAME },
    });
  },
  fetchAll: (params?: Record<string, any>) => {
    return API({
      path: REACT_APP_API_PANEL_URL + FIND_ALL,
      method: 'GET',
      params,
      headers: { project: REACT_APP_PROJECT_NAME },
    });
  },
  fetchOne: ({ id, ...params }: Record<string, any>) => {
    return API({
      path: REACT_APP_API_PANEL_URL + FIND_ONE,
      method: 'GET',
      pathParams: { id },
      params,
      headers: { project: REACT_APP_PROJECT_NAME },
    });
  },
};
